export const WHO_AM_I = "auth/who_am_i";
export const AUTHENTICATION_REQUEST = "shoki/authentication_request";
export const LOGOUT_REQUEST = "shoki/logout_request";
